module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation/deposit/menu-items.json
// module id = 2379
// module chunks = 1